export default __webpack_public_path__ + "static/media/Armguards of the Victorious Elite.038992d0.jpg";